// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__OPbro","ranges":"BmiRanges_ranges__2Z3ur"};